import { DeckSharesList } from '@/components/deck-shares';
import { PageContainer } from '@startupquickstart/frontend';

/**
 * Presentation Shares list page — every prospect link, with how many times each
 * one has been opened.
 */
export function DeckSharesPage() {
  const breadcrumbs = [
    { label: 'Home', href: '/' },
    { label: 'Presentation Shares', current: true },
  ];

  return (
    <PageContainer>
      <DeckSharesList breadcrumbs={breadcrumbs} />
    </PageContainer>
  );
}
